import { Controller } from '@hotwired/stimulus'
import '@drenso-toast-ui/editor/dist/toastui-editor-viewer.css'
import '../stylesheets/toast-editor.css'

export default class extends Controller {
  connect() {
    this.initializeViewer()
  }

  async initializeViewer() {
    // Get the markdown content from the div
    const content = this.element.textContent.trim()
    
    // Create a div for the viewer
    const viewerContainer = document.createElement('div')
    viewerContainer.style.width = '100%'
    this.element.insertAdjacentElement('afterend', viewerContainer)
    this.element.style.display = 'none'

    // Import viewer dynamically to reduce initial bundle size
    const { default: Viewer } = await import('@drenso-toast-ui/editor/dist/toastui-editor-viewer')
    
    // Initialize viewer
    this.viewer = new Viewer({
      el: viewerContainer,
      initialValue: content,
      width: '100%'
    })
  }

  disconnect() {
    if (this.viewer) {
      this.viewer.destroy()
    }
  }
}
